import { render } from "./GeneralMedicine.vue?vue&type=template&id=196e1348&scoped=true"
import script from "./GeneralMedicine.vue?vue&type=script&lang=ts"
export * from "./GeneralMedicine.vue?vue&type=script&lang=ts"

import "./GeneralMedicine.vue?vue&type=style&index=0&id=196e1348&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-196e1348"

export default script